module.exports = __webpack_public_path__ + "assets/img/text_logo.6698a805.png";